import mountSkypeIfNeed from '../components/UcwaChatView';
import type { IO365ShellShim } from '@suiteux/suiteux-shell';
import { getStore } from '../../store/chatStore';

export default function setIsSkypePaneShown(isShown: boolean) {
    const originalValue = getStore().isChatCalloutShown;
    const o365shell: IO365ShellShim = (window as any).O365Shell;

    if (isShown && !originalValue) {
        o365shell.FlexPane.OpenFlexPaneForProvider('Skype');
        mountSkypeIfNeed();
    } else if (!isShown && originalValue) {
        o365shell.FlexPane.CloseFlexPaneForProvider('Skype');
    }
}
